<div class="review-container">
    <dw-message [message]="message"></dw-message>

    <div dwRow *ngIf="kickoffArgs.reviewSummaries?.length>0">
        <div dwCol="12">
            <label class="label">Employees</label>

            <div class="dw-chip-container">
                <div *ngFor="let reviewSummary of kickoffArgs?.reviewSummaries; let i = index" class="dw-chip">
                    <div class="dw-chip dw-chip-100">
                        <div class="dw-chip-label-with-remove"> {{reviewSummary.EmployeeEthosUserIdDisplay}}</div>
                        <div class="dw-chip-icon" (click)="removeItem(reviewSummary, i)"
                            [hidden]="kickoffArgs?.reviewSummaries.length == 1">
                            <i class="fa fa-times-circle"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- Section to allow employees to be added -->
    <div dwRow *ngIf="!allowAddEmployees && !hideAddEmployees">
        <div dwCol="12">
            <button class="btn btn-success" (click)="allowAddEmployees = true">Add Employees</button>
        </div>
    </div>
    <div *ngIf="allowAddEmployees" class="employee-add-container">
        <div dwRow>
            <div dwCol="6">
                <label class="label">Employee</label>
                <dw-auto-complete-lookup [(ngModel)]="employeeIdToAdd" [lookupId]="employeeLookupId"
                    useServerSearch="true" [paramValues]="params">
                </dw-auto-complete-lookup>
            </div>
            <div dwCol="6">
                <label class="label"></label>
                <button class="btn btn-success mt-4" (click)="addEmployee(employeeToAdd)" [disabled]="!this.employeeIdToAdd">Add</button>
            </div>
        </div>
    </div>
        
    <div dwRow>
        <div dwCol="6">
            <label class="label">Evaluation Due Dates <i class="fa fa-info-circle"
                    title="Dates the employee self-evaluation and the supervisor evaluation are due"></i></label>
            <dw-date2 [(ngModel)]="evalDueDate" showTime="false" [dateOptions]="dateOptions"></dw-date2>
        </div>
    </div>

    <div dwRow>
        <div dwCol="6">
            <label class="label">Review Due Dates <i class="fa fa-info-circle"
                    title="Date to complete the review - meeting with the employee and going over the evaluation results"></i></label>
            <dw-date2 [(ngModel)]="reviewDueDate" showTime="false" [dateOptions]="dateOptions"></dw-date2>
        </div>
    </div>
</div>